import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { provideZonelessChangeDetection } from '@angular/core';

import { createEntityAuthInterceptor } from './app/http/create-entity-auth.interceptor';
import { CreateEntityElementComponent } from './app/create-entity-element.component';

/**
 * Entry point for the POC "self-contained web component" bundle
 * (CLNAPP-1269, Approach B). This script is loaded via a plain
 * `<script src="...">` tag by any host page — it bootstraps its own
 * Angular runtime and registers `<wcg-create-entity>` as a custom element.
 * The host supplies the token, event source and Jemma URL as element inputs
 * (see `CreateEntityElementComponent`); nothing environment-specific is baked in.
 *
 * Zoneless on purpose: the host page (dashboard) already loads zone.js for
 * its own Angular app, so this widget avoids bundling/patching a second
 * zone.js instance, which is one of the main risks Approach B calls out.
 */
const ELEMENT_TAG_NAME = 'wcg-create-entity';

createApplication({
    providers: [provideZonelessChangeDetection(), provideHttpClient(withInterceptors([createEntityAuthInterceptor]))]
})
    .then(appRef => {
        if (customElements.get(ELEMENT_TAG_NAME)) {
            // Script tag injected more than once (e.g. dialog re-opened) — no-op.
            return;
        }

        const element = createCustomElement(CreateEntityElementComponent, { injector: appRef.injector });
        customElements.define(ELEMENT_TAG_NAME, element);
    })
    .catch(error => {
        console.error('[create-entity-widget] failed to bootstrap', error);
    });
